import { Component, OnInit } from '@angular/core';
import { User } from '../../_models/user';
import { InvoiceMenu } from '../../_models/invoiceMenu';
import { Globals } from '../../_models/globals';
import { HttpClient, HttpErrorResponse, HttpHeaders } from "@angular/common/http";
//import { LocalStorageService, SessionStorageService, LocalStorage, SessionStorage } from 'angular-web-storage';
import { environment } from "../../../environments/environment";
import { AlertService } from '../../_services/alert.service';
import { ApiIntegration } from '../../_services/api.integration';

@Component({
  selector: 'app-marketing',
  templateUrl: './marketing.component.html',
  styleUrls: ['./marketing.component.scss'],
})
export class MarketingComponent implements OnInit {

  imageUrl: string;
  track: any = {};
  disableStatuses = true;

  trackData: any = {};
  track1: any = {};
  imageUrlMobile: string;
  menuName: any;
  menuNameError: any;

  menuUrl: any;
  menuUrlError: any;
  bannerUrlError: any;
  bannerUrl: any;
  alterError: any;
  alter: any;

  uploadImageMobile: string;
  uploadImage: string;
  productImage: string = "/assets/images/default-product.png";
  productImageMobile: string = "/assets/images/default-product.png";
  errorMessage: string;
  errorMessageMobile: string;

  tabClicked: string = 'trackMenu';
  userDrop2: string = 'trackMenu';
  trackMenuDisplay: string = 'F';

  allOrdersMainMenu: InvoiceMenu[] = [
    { displayName: "Track Menu", tabClicked: "trackMenu", additional: "N" },
    { displayName: "Track Banner", tabClicked: "trackBanner", additional: "N" },
  ];

  trackingMenuList: any;

  constructor(public user: User, private g: Globals, private http: HttpClient, private alertService: AlertService, private api: ApiIntegration) {
    //this.populateTabData(this.tabClicked);
    if (this.tabClicked === 'trackMenu') {
      this.getTrackMenuList();
    }

  }


  populateTabData(triggered) {
    this.tabClicked = triggered;
    this.g.pageTab = triggered;
    if (this.tabClicked === 'trackMenu') {
      this.getTrackMenuList();
    } else if (this.tabClicked === 'trackBanner') {
      this.getTrackBanner();
    }
  }

  ngOnInit() { }

  /* url="./assets/images/1-dhl.png";

  onselectFile(e){
  if(e.target.files){
  var reader = new FileReader();
  reader.readAsDataURL(e.target.files[0]);
  reader.onload =(event:any)=>{
  this.url = event.target.result;
  }
  }} */

  loadImage(event) {
    this.productImage = URL.createObjectURL(event.target.files[0]);
    this.uploadImage = event.target.files[0];
    this.errorMessage = "";
    this.submitImage();
  }

  ignoreImage() {
    this.productImage = "/assets/images/default-product.png";
    this.uploadImage = null;
    this.imageUrl = null;
    this.errorMessage = "";
  }
  loadImageMobile(event) {
    this.productImageMobile = URL.createObjectURL(event.target.files[0]);
    this.uploadImageMobile = event.target.files[0];
    this.errorMessageMobile = "";
    this.submitImageMobile();
  }

  ignoreImageMobile() {
    this.productImageMobile = "/assets/images/default-product.png";
    this.uploadImageMobile = null;
    this.imageUrlMobile = null;
    this.errorMessageMobile = "";
  }

  typemenuName() {
    this.menuNameError = '';
    if (this.menuName == '' || this.menuName === undefined || this.menuName === null || this.menuName == 'undefined') {
      this.menuNameError = "Please enter the Menu Name"

    }
  }

  typemenuUrl() {
    this.menuUrlError = '';
    if (this.menuUrl == '' || this.menuUrl === undefined || this.menuUrl === null || this.menuUrl == 'undefined') {
      this.menuUrlError = "Please enter the Menu url"
    }
  }

  typeAlter() {
    this.alterError = '';
    if (this.track1.altText == '' || this.track1.altText === undefined || this.track1.altText === null || this.track1.altText == 'undefined') {
      this.alterError = "please enter the Alternate text"
    }
  }

  typeBannerUrl() {
    this.bannerUrlError = '';
    if (this.track1.bannerUrl == '' || this.track1.bannerUrl === undefined || this.track1.bannerUrl === null || this.track1.bannerUrl == 'undefined') {
      this.bannerUrlError = "please enter the Banner Url"
    }
  }

  submitImage() {
    this.g.loaderDisplay = "display";
    const file = this.uploadImage;
    const formData: FormData = new FormData();
    formData.append('file', file);
    var headerObj = new HttpHeaders();
    //headerObj = headerObj.append('content-Type', 'multipart/form-data');
    headerObj = headerObj.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/uploadImageToS3', formData, { headers: headerObj }).subscribe(data => {
      this.g.loaderDisplay = "";
      if (data['code'] == 200) {
        this.imageUrl = data['message'];
      } else {
        this.imageUrl = "";
      }
    },
      (err: HttpErrorResponse) => {
        this.g.loaderDisplay = "";
        this.errorMessage = "Upload Image Failed Please Re-try";
      });
  }

  submitImageMobile() {
    this.g.loaderDisplay = "display";
    const file = this.uploadImageMobile;
    const formData: FormData = new FormData();
    formData.append('file', file);
    var headerObj = new HttpHeaders();
    //headerObj = headerObj.append('content-Type', 'multipart/form-data');
    headerObj = headerObj.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/uploadImageToS3', formData, { headers: headerObj }).subscribe(data => {
      this.g.loaderDisplay = "";
      if (data['code'] == 200) {
        this.imageUrlMobile = data['message'];
      } else {
        this.imageUrlMobile = "";
      }
    },
      (err: HttpErrorResponse) => {
        this.g.loaderDisplay = "";
        this.errorMessageMobile = "Upload Image Failed Please Re-try";
      });
  }

  getTrackMenu() {
    this.g.loaderDisplay = "display";
    this.api.getTrackingMenu(this.user.accountOwnerId, this.user.organizationId).subscribe((data: any) => {
      this.g.loaderDisplay = "";
      this.track = data;
    },
      err => {
        this.g.loaderDisplay = "";
        this.alertService.error('Error', err);
      });
  }

  getTrackMenuList() {
    this.g.loaderDisplay = "display";
    this.api.getTrackingMenuLi(this.user.accountOwnerId, this.user.organizationId).subscribe((data: any) => {
      this.g.loaderDisplay = "";
      this.trackingMenuList = data.trackingMenuList;
      if (this.trackingMenuList.length >= 5) {
        this.trackMenuDisplay = 'T';
      }
    },
      err => {
        this.g.loaderDisplay = "";
        this.alertService.error('Error', err);
      });
  }

  getTrackBanner() {
    this.g.loaderDisplay = "display";
    this.api.getTrackingBanner(this.user.accountOwnerId, this.user.organizationId).subscribe((data: any) => {
      this.g.loaderDisplay = "";
      this.track1 = data;
      this.imageUrlMobile = this.track1.mobileBanner;
      this.imageUrl = this.track1.webBanner;
    },
      err => {
        this.g.loaderDisplay = "";
        this.alertService.error('Error', err);
      });
  }

  manageTrackingMenu() {
    this.menuNameError = "";
    this.menuUrlError = "";

    if (!this.menuName) {
      this.menuNameError = "Please enter the Menu Name";
    }

    if (!this.menuUrl) {
      this.menuUrlError = "Please enter the Menu URL";
    }

    if (this.menuNameError != "" || this.menuUrlError != "") {
      return false
    }

    this.g.loaderDisplay = "display";
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/manageTrackingPageMenu', {
      "accountOwnerId": this.user.accountOwnerId,
      "menuName": this.menuName,
      "menuUrl": this.menuUrl,
      "organizationId": this.user.organizationId
    },
      { headers: header1 }).subscribe(data => {
        this.g.loaderDisplay = "";
        if (data['code'] == 200) {

          this.alertService.success('Tracking Menu details', 'Edited Successfully');
          this.getTrackMenu();
          this.menuName = "";
          this.menuUrl = "";
          this.getTrackMenuList();
        } else {
          this.alertService.error('Error', data['message']);

        }
        this.g.loaderDisplay = "";

      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
        });
  }

  TrackingBannerService() {
    this.g.loaderDisplay = "display";
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/manageTrackingPageBanners', {
      "accountOwnerId": this.user.accountOwnerId,
      "altText": this.track1.altText,
      "bannerUrl": this.track1.bannerUrl,
      "webBanner": this.imageUrl,
      "mobileBanner": this.imageUrlMobile,
      "organizationId": this.user.organizationId
    },
      { headers: header1 }).subscribe(data => {
        this.g.loaderDisplay = "";
        if (data['code'] == 200) {

          this.alertService.success('TrackingBanner details', 'Edited Successfully');

        } else {
          this.alertService.error('Error', data['message']);
        }
        this.g.loaderDisplay = "";

      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
        });
  }

  selectedDeleteReturn() {
    this.trackData = this.track;
  }

  deleteReturn(trackData) {
    this.g.loaderDisplay = "display";
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/deleteTrackingPageMenu', {
      "id": trackData.id,
      "organizationId": this.user.organizationId
    },
      { headers: header1 }).subscribe(data => {
        this.g.loaderDisplay = "";
        if (data['code'] == 200) {
          this.alertService.success('Tracking Menu', 'Deleted Successfully');
          this.getTrackMenuList();
        } else {
          this.alertService.error('Error', data['message']);
        }
        this.g.loaderDisplay = "";
      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
        }
      );
  }

}
